/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Regenerate_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Regenerate SCIM Token" |
*
* @param {Scim_Regenerate_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_regenerate_confirm_title = /** @type {((inputs?: Scim_Regenerate_Confirm_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Regenerate_Confirm_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("SCIM-Token erneuern")
	return /** @type {LocalizedString} */ ("Regenerate SCIM Token")
});